export const playOffTypes = Object.freeze({
    IS_CHAMPION: 'isChampion',
    IS_PLAY_OFF: 'isPlayOff',
    IS_SUDDEN_DEATH: 'isSuddenDeath'
});

export const playOffStatuses = Object.freeze({
    NOT_PLAYING: 0,
    PLAYING: 1,
    LOST: 2
});

export const cellTypes = Object.freeze({
    POSITION: 'pos',
    MOVERS: 'movers',
    PLAYER: 'player',
    PAR: 'par',
    HOLE: 'hole',
    TOTAL: 'total',
    TODAY: 'today',
    R1: 'r1',
    R2: 'r2',
    R3: 'r3',
    R4: 'r4'
});

export const viewTypes = Object.freeze({
    SUMMARY: 'summary',
    R_SCORE: 'r-score',
    HOLE_BY_HOLE: 'hole-by-hole'
});

export const getCellModifierByType = (type) => {
    switch (type) {
        case cellTypes.R1:
        case cellTypes.R2:
        case cellTypes.R3:
        case cellTypes.R4:
            return 'round';
        case cellTypes.TOTAL:
            return 'today';
        default:
            return type;
    }
};

export const getTitleByType = (type) => {
    switch (type) {
        case cellTypes.TOTAL:
            return 'Score';
        case cellTypes.TODAY:
            return 'Round';
        default:
            return type;
    }
};

export const noFavoriteMessage = {
    title: 'Favourite players',
    body: 'You don’t have any favourites added yet, click on the star button to add them.'
};

export const noResultsMessage = {
    title: 'No results',
    body: 'Please try making your search a little wider.'
};

export const getCellTypeForRound = (round) => {
    switch (round) {
        case '1': return cellTypes.R1;
        case '2': return cellTypes.R2;
        case '3': return cellTypes.R3;
        case '4': return cellTypes.R4;
        default:
            return cellTypes.TODAY;
    }
};
